import React, { useState } from 'react';
import './Foods.css';
import Items from './../FoodData/FoodsItems';

const Foods = () => {
   
    const [items, setItems] = useState(Items);

    const filterItem = (categItem) => {
        
        const updatedItem = Items.filter((curElem) => {
            return curElem.category === categItem;
        })
        setItems(updatedItem);
    }

    return (
        <div>
            <section className='foods'>
                <div className='container'>
                    <div className='row'>
                        <div className='foods-btn'>   
                            <div className='col-12'>
                                <button onClick={() => setItems(Items)}>All</button>
                                <button onClick={() => filterItem('breakfast')}>Breakfast</button>
                                <button onClick={() => filterItem('lunch')}>Lunch</button>
                                <button onClick={() => filterItem('dinner')}>Dinner</button>
                            </div>
                        </div>
                    </div>

                    <div className='foods-area'>
                        <div className='row'>

                        {
                            items.map(item => {
                                const {images, name, price, description} = item;
                        
                                return(
                                    <div className='col-lg-4'>
                                        <div className='foods-item'>
                                            <img src={images} alt="img" class="img-fluid" />
                                            <h5>{name}</h5>
                                            <p>{description}</p>
                                            <span>{price}</span>
                                        </div>
                                    </div>
                                )  
                            })
                        }

                        <div className='checkOut'>
                            <h5>Checkout Your Food</h5>
                        </div>

                        </div>

                      
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Foods;